module.exports = __webpack_public_path__ + "static/portugal-flag-fbf130c4cf651d793ef080714eb235d7.svg";